import { render } from "./Jalali.vue?vue&type=template&id=2fa98f8a"
import script from "./Jalali.vue?vue&type=script&lang=js"
export * from "./Jalali.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__